// extracted by mini-css-extract-plugin
module.exports = {"contactPageWrapper":"contact_contactPageWrapper__2PgHB","contactPageIntroBody":"contact_contactPageIntroBody__1GDQk"};